export default __webpack_public_path__ + "static/media/Logo_AG+.431302ac.svg";